import { APPS } from "@/data/apps";
import type { AppDef, AppId } from "@/types";

/**
 * OAuth client_id → Hive app. Client ids are per-deployment registrations
 * (seeded in server/src/seed/seed.ts) while AppIds are the desktop catalog,
 * so the bridge has to be explicit. Unknown clients (e.g. third-party RPs)
 * simply get no catalog entry — callers fall back to the client's registered
 * logo_uri or the Hive mark.
 */
const CLIENT_APP_IDS: Record<string, AppId> = {
  "ares-ide": "ares",
  "athena-web": "athena",
  "byonc-console": "byonc",
  "garlic-web": "garlic",
  "appgraph-web": "appgraph",
};

/** Catalog entry for an OAuth client, or null for unknown/third-party clients. */
export function appForClient(clientId: string | null | undefined): AppDef | null {
  if (!clientId) return null;
  const appId = CLIENT_APP_IDS[clientId];
  return appId ? APPS[appId] : null;
}
